import { render, staticRenderFns } from "./mobileNewDynamic.vue?vue&type=template&id=131eb4ac&scoped=true"
import script from "./mobileNewDynamic.vue?vue&type=script&lang=js"
export * from "./mobileNewDynamic.vue?vue&type=script&lang=js"
import style0 from "./mobileNewDynamic.vue?vue&type=style&index=0&id=131eb4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131eb4ac",
  null
  
)

export default component.exports